import { render, staticRenderFns } from "./userconfigmgt.vue?vue&type=template&id=d30454f2"
import script from "./userconfigmgt.vue?vue&type=script&lang=js"
export * from "./userconfigmgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports